import doctor from '../assets/projects/doctor.png';
import learn from '../assets/projects/learn.png';
import harper from '../assets/projects/harper.png';
import convert from '../assets/projects/covert.png';

export const data = [
  {
    id: 1,
    name: 'doctors portal',
    image: doctor,
    github: 'https://github.com/tonmoycoder/doctors-portal-client-side-practice',
    live: 'https://doctors-portal-practice-7bf5f.web.app/',
  },
  {
    id: 2,
    name: 'learning platform',
    image: learn,
    github: 'https://github.com/tonmoycoder/Learning-Platform',
    live: 'https://learning-platform-assign-1c3d9.web.app/',
  },
  {
    id: 3,
    name: 'Harper courier',
    image: harper,
    github: 'https://github.com/tonmoycoder/Harper-Client-Side',
    live: 'https://assignment-11-crud.web.app/',
  },
  {
    id: 4,
    name: 'Number to Word converter',
    image: convert,
    github: 'https://github.com/tonmoycoder/Number-To-Word-Converter',
    live: 'https://tonmoycoder.github.io/Number-To-Word-Converter/',
  },
];
